/**
 * The figure a `stats_counter` stat displays, whatever wrote the row.
 *
 * The wizard stores one string — `number: "10k+"` — and the homepage section
 * reads exactly that. The admin builder instead wrote `value`, `prefix` and
 * `suffix`, which the section never looked at: a stat added or edited in the
 * builder rendered with no figure at all, and the builder showed every
 * wizard-made stat as blank. `number` is the stored key; the three-part form
 * is still read so rows saved by the old builder keep their figure.
 */
export function statNumber(stat: Record<string, unknown> | null | undefined): string {
  const number = stat?.number;
  if (typeof number === 'string' || typeof number === 'number') return String(number);
  const part = (v: unknown) => (typeof v === 'string' || typeof v === 'number' ? String(v) : '');
  return `${part(stat?.prefix)}${part(stat?.value)}${part(stat?.suffix)}`;
}
